import { CURRENCY, DropdownItem } from "types";
import { Fees } from "./value-at-risk";

export enum BASE_PROJECT_TYPE {
  CONSTRUCTION = "Construction",
  OPERATIONAL_PROPERTY = "OperationalProperty",
}

export enum PROJECT_STATUS {
  OPEN = "Open",
  CLOSED = "Closed",
}

export enum PROJECT_CONSTRUCTION_TYPE {
  COMBUSTIBLE = "Combustible",
  NON_COMBUSTIBLE = "NonCombustible",
}

export type ProjectListItem = {
  id: string;
  name: string;
  type: BASE_PROJECT_TYPE;
  status: PROJECT_STATUS;
  country: string;
  currency?: CURRENCY;
  totalPremium?: number;
  linePercent?: number;
  policyStartDate: string;
  policyExpireDate: string;
  policyNumber: string;
  insuranceCompanyName: string;
  readyToBeReallocated: boolean;
  var?: number;
  constructionValue: number;
  buildDate: string;
  riskScore: number;
  referenceNumber: string;
}

export type OperationalPropertyFees = {
  designFees: number;
  ohProfit: number;
  debrisRemoval: number;
}

export type BaseProjectDetails = {
  id: string;
  name: string;
  insuranceCompanyName: string;
  status: PROJECT_STATUS;
  riskScoreMax: number;
  type: BASE_PROJECT_TYPE;
  fees: Fees;
  currency: CURRENCY;
}

export type ProjectDetails = BaseProjectDetails & {
  closingReason: string;
  reopeningReason: string;
  insuredCompanyName: string;
  principalCompanyId: string;
  parentCompany: DropdownItem;
  projectType: DropdownItem;
  projectBusinessType: DropdownItem;
  constructionType: PROJECT_CONSTRUCTION_TYPE;
  linePercent: number;
  policyStartDate: string;
  policyExpireDate: string;
  extensionEndorsementDate: string;
  policyNumber: string;
  description: string;
  dsu: number;
  contractValue: number;
  projectedFinalAccount: number;
  tiv: number;
  pmlPercent: number;
  brPremium: number;
  dsuPremium: number;
  triaPremium: number;
  totalPremium: number;
  readyToBeReallocated: boolean;
  primaryRiskEngineer: string;
  primarySiteContact: string;
  disclaimerCompanyName: string;
  isDeployment2Project: boolean;
  isDeployment21Project: boolean;
  client: string;
  buildDate: string;
  grossFloorArea: number;
  numberOfRooms: number;
  referenceNumber: string;
  businessInterruption: number;
  constructionValue: number;
  var: number;
  biPremium: number;
  propertyPremium: number;
  plannedControls?: string[];
}

export type ProjectDetailSiteContact = BaseProjectDetails & {
  isPrimarySiteContact: boolean;
  canUploadDocuments: boolean;
}

export interface ProjectTypeListItem {
  id: string;
  value: string;
  creationDateTime: Date;
  businessTypes: DropdownItem[];
  isNewProjectType: boolean;
}
